import { render, staticRenderFns } from "./LIghtboxWithSlider.vue?vue&type=template&id=6f6ae62b&lang=pug"
import script from "./LIghtboxWithSlider.vue?vue&type=script&lang=js"
export * from "./LIghtboxWithSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports